import { keyframes as i, styled as n, modifier as t, css as a } from "@lokalise/styled";
const o = i`
    0% {
        opacity: .3;
    }
    50% {
        opacity: 1;
    }
    100% {
        opacity: .3;
    }
`, m = n.div`
	width: 100%;
	${t(
  "$animated",
  a`
			animation-name: ${o};
			animation-duration: 1.5s;
			animation-iteration-count: infinite;
		`
)}
`;
export {
  m as Container
};
//# sourceMappingURL=styles.js.map
